import { useEffect } from "react";
import ReactGA from "react-ga4";

export const useGoogleAnalyticsPageView = (eventId: string) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      ReactGA.send({ hitType: "pageview", event_id: eventId });
    }
  }, [eventId]);
};
